import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { IntlService } from '@progress/kendo-angular-intl';
import { PageBaseComponent } from './page-base.component';
import { AuthService, DatasourceService } from '@app/core/services';
import { NotificationService } from "@progress/kendo-angular-notification";
import { DialogService, DialogRef, DialogCloseResult } from "@progress/kendo-angular-dialog";


@Component({
  selector: 'vehicle-edit-cost',  
  styleUrls: ['./styles/styles-wrapper.css', './styles/styles-form.css'],
  styles: [`
    form {
      padding: 0 15px 132px 15px;
    }
  `],  
  template: `

    <div class="wrapper-route-0">

      <images-scrollview [id]="id"></images-scrollview> 

      <vehicle-info [id]="id" (complete)="onComplete($event)"></vehicle-info>
      
      <div class="k-block" *ngIf="loading">
        <kendo-loader [type]="'pulsing'" [size]="'medium'"></kendo-loader>
      </div>

      <form novalidate [formGroup]="form" *ngIf="!loading && vehicle.cost_crane == null">
        <div class="example-wrapper form-detail">        
          <div class="row">
            <div class="col-field">
              <kendo-label text="Costo de grúa:"></kendo-label>
              <kendo-textbox-container>
                <kendo-numerictextbox formControlName="cost_crane" [format]="'c2'" [min]="0" [autoCorrect]="true"></kendo-numerictextbox>
              </kendo-textbox-container> 
              <div *ngIf="f.cost_crane.invalid && (f.cost_crane.dirty || f.cost_crane.touched)">                  
                <div *ngIf="f.cost_crane.errors">
                  <kendo-formerror *ngIf="f.cost_crane.errors.required">
                    Error: Campo requerido.
                  </kendo-formerror>
                </div>   
              </div>
            </div>              
          </div>
        </div>
      </form>

      <kendo-floatingactionbutton icon="arrow-left" themeColor="secondary" [offset]="{ x: '12px', y: '68px' }" [align]="{ horizontal: 'start', vertical: 'bottom' }" positionMode="fixed" (click)="goBack()"></kendo-floatingactionbutton>

      <kendo-floatingactionbutton icon="save" themeColor="info" [offset]="{ x: '12px', y: '68px' }" [align]="{ horizontal: 'end', vertical: 'bottom' }" positionMode="fixed" (click)="onSave()" [disabled]='!form.valid && !loading' *ngIf="vehicle.cost_crane == null"></kendo-floatingactionbutton>

    </div>

    <div kendoDialogContainer></div>

  `    
})
export class VehicleEditCostComponent extends PageBaseComponent implements OnInit {
  
  public id: number = 0;

  public mode = 'EDIT';

  public table: string = 'vehicles_inventories';

  public vehicle: any = {};
  
  public form: FormGroup = new FormGroup({
      'cost_crane': new FormControl(0, Validators.required)
  });

  public loading = false;


  constructor(public authService: AuthService, protected router: Router, protected route: ActivatedRoute, protected service : DatasourceService, protected intl: IntlService, private notificationService: NotificationService, private dialogService: DialogService) { 

    super(authService, router)
    // console.log('VehicleEditCostComponent');
    let id = this.route.snapshot.paramMap.get('id');
    this.id = (id != null) ? parseInt(id): 0;        

  }

  public onComplete(event: any) {

    this.vehicle = event.dataItem;
    this.form.patchValue({
      cost_crane: this.vehicle.cost_crane
    });

  }

  // protected getFormGroup(): FormGroup {

  //   return new FormGroup({
  //     'cost_crane': new FormControl(this.vehicle.cost_crane, Validators.required),
  //   });

  // };

  ngOnInit() {

    // this.form = this.getFormGroup();
    // this.update();

  }

  // convenience getter for easy access to form fields
  get f() { return this.form.controls; }

  protected getData(formGroup: FormGroup): Object {

    return Object.assign({}, formGroup.value, {
        id: this.id,
        id_vehicle_status: 2
      });

  };

  // public update(): void {

  //   this.loading = true;

  //   let id: any = this.route.snapshot.paramMap.get('id');

  //   this.service.getById(this.table, parseInt(id))
  //     .subscribe(
  //       (result: any) => {
  //         console.log(result);
  //         this.vehicle = result;

  //         this.loading = false;

  //         this.form = this.getFormGroup();
  //       },
  //       (error: any) => {
  //         console.log(error)
  //         // this.loading = false;
  //       });

  // }

  public onSave(): void {
  
    let data = this.getData(this.form);
    console.log('data', data)

    this.loading = true;

    if(this.mode == 'EDIT'){
        // console.log(data);
      this.service.updateRow(this.table, data) 
        .subscribe(
          (res: any) => {
            console.log("PUT Request is successful: ", this.table, data);
            console.log("mode = " + this.mode);
            // this.save.emit({mode: this.mode, dataItem: res.data[0]});

            // this.notificationService.show({
            //     content: `Se registró con éxito el costo de grúa de ${this.intl.formatNumber(res.data[0].cost_crane, "c2")}`,
            //     hideAfter: 1000,
            //     position: { horizontal: "center", vertical: "top" },
            //     animation: { type: "fade", duration: 400 },
            //     type: { style: "success", icon: true },
            //   });

            // this.update();

            this.loading = false;

            const dialog: DialogRef = this.dialogService.open({
              title: "Éxito",
              content: `Se registró con éxito el costo de grúa de ${this.intl.formatNumber(res.data[0].cost_crane, "c2")}`,
              actions: [{ text: "Ok", primary: true }],
              width: '80%',
              // height: 200,
              // minWidth: 250,
            });
          
            dialog.result.subscribe((result) => {
              if (result instanceof DialogCloseResult) {
                  // console.log("close");
              }
              this.goBack()
            });

          },
          (fail: any) => {        
            console.log("Error", fail);
            // this.alertService.showError(fail.error.detail.sql + ' ' + fail.error.detail.sqlMessage);
          }
        ); 
    }

  }

  public goBack() {

      // console.log(event);
    this.router.navigate([`/vehicle_actions/${this.id}`]);

  }
      
}